import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { IvrService } from './ivr.service';
import { IvrModel } from './ivr.model';

@Injectable()
export class IvrsResolver implements Resolve<IvrModel[]> {
  constructor(private ivrService: IvrService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IvrModel[]> | Promise<IvrModel[]> | IvrModel[] {
    return this.ivrService.getIvrs();
  }
}
